/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementsByTagName('body')[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
      });
    }
    setTimeout(function () {
      window.dispatchEvent(new Event('resize.resize-select'));
    }, 10);
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        new FacetsToggle();
         closeAllFilters();
  setupColorSwatchTooltips();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    new FacetsToggle();
   closeAllFilters();
  setupColorSwatchTooltips();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));

  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
    
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove)
  closeAllFilters()
          setupColorSwatchTooltips();

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new FacetsToggle();
});



// CODE-FOR-CLOSING-FILTERS-ON-PAGE-LOAD

  // document.addEventListener('DOMContentLoaded', function () {
  //   const allFilters = document.querySelectorAll('.thb-filter.js-filter');
  //   allFilters.forEach(function (filter) {
  //     filter.removeAttribute('open');
  //   });
  // });

function closeAllFilters() {
  const allFilters = document.querySelectorAll('.thb-filter.js-filter');
  allFilters.forEach(function (filter) {
    filter.removeAttribute('open');
  });
}

// Run on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function () {
  closeAllFilters();
});






// Add this script to your theme.js file or in a <script> tag

// document.addEventListener('DOMContentLoaded', function() {
//   // Style fixes for the color swatches and tooltips
//   const styleElement = document.createElement('style');
//   styleElement.textContent = `
//     /* Remove diagonal lines from color swatches */
//     ul[class*="-color"] label::before {
//       display: none;
//     }
    
//     /* Make color swatches fully visible */
//     ul[class*="-color"] label {
//       position: relative;
//       overflow: visible;
//     }
    
//     /* Style the color swatch to remain visible on hover */
//     ul[class*="-color"] label:hover {
//       opacity: 1 !important;
//     }
    
//     /* Custom tooltip style */
//     .color-name-tooltip {
//       position: absolute;
//       background: #000;
//       color: #fff;
//       padding: 3px 8px;
//       border-radius: 4px;
//       font-size: 12px;
//       white-space: nowrap;
//       pointer-events: none;
//       z-index: 1000;
//       text-align: center;
//       box-shadow: 0 2px 5px rgba(0,0,0,0.2);
//     }
    
//     /* Arrow for the tooltip */
//     .color-name-tooltip:after {
//       content: '';
//       position: absolute;
//       bottom: -5px;
//       left: 50%;
//       transform: translateX(-50%);
//       width: 0;
//       height: 0;
//       border-left: 5px solid transparent;
//       border-right: 5px solid transparent;
//       border-top: 5px solid #000;
//     }
//   `;
//   document.head.appendChild(styleElement);
  
//   // Target all color filter labels
//   const colorLabels = document.querySelectorAll('ul[class*="-color"] label');
  
//   colorLabels.forEach(label => {
//     // Get original tooltip data
//     const originalTooltip = label.getAttribute('data-tooltip') || '';
    
//     // Extract only the color name (remove the count in parentheses)
//     const colorName = originalTooltip.replace(/\s*\(\d+\)$/, '');
    
//     // Add mouse events for tooltip handling
//     label.addEventListener('mouseenter', function(e) {
//       // Remove any existing tooltips
//       const existingTooltip = document.querySelector('.color-name-tooltip');
//       if (existingTooltip) {
//         existingTooltip.remove();
//       }
      
//       // Create tooltip element
//       const tooltip = document.createElement('div');
//       tooltip.className = 'color-name-tooltip';
//       tooltip.textContent = colorName;
//       document.body.appendChild(tooltip);
      
//       // Position tooltip just above the swatch
//       const rect = this.getBoundingClientRect();
//       const tooltipRect = tooltip.getBoundingClientRect();
      
//       tooltip.style.left = rect.left + (rect.width / 2) - (tooltipRect.width / 2) + 'px';
//       tooltip.style.top = (rect.top - tooltipRect.height - 10) + window.scrollY + 'px'; // Account for scroll position
//     });
    
//     label.addEventListener('mouseleave', function() {
//       // Remove tooltip when mouse leaves
//       const tooltip = document.querySelector('.color-name-tooltip');
//       if (tooltip) {
//         tooltip.remove();
//       }
//     });
//   });
// }); 

function setupColorSwatchTooltips() {
  // Style fixes for the color swatches and tooltips
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    /* Remove diagonal lines from color swatches */
    ul[class*="-color"] label::before {
      display: none;
    }
    
    /* Make color swatches fully visible */
    ul[class*="-color"] label {
      position: relative;
      overflow: visible;
    }
    
    /* Style the color swatch to remain visible on hover */
    ul[class*="-color"] label:hover {
      opacity: 1 !important;
    }
    
    /* Custom tooltip style */
    .color-name-tooltip {
      position: absolute;
      background: #000;
      color: #fff;
      padding: 3px 8px;
      border-radius: 4px;
      font-size: 12px;
      white-space: nowrap;
      pointer-events: none;
      z-index: 1000;
      text-align: center;
      box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    }
    
    /* Arrow for the tooltip */
    .color-name-tooltip:after {
      content: '';
      position: absolute;
      bottom: -5px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid #000;
    }
  `;
  document.head.appendChild(styleElement);

  // Target all color filter labels
  const colorLabels = document.querySelectorAll('ul[class*="-color"] label');

  colorLabels.forEach(label => {
    // Get original tooltip data
    const originalTooltip = label.getAttribute('data-tooltip') || '';
    const colorName = originalTooltip.replace(/\s*\(\d+\)$/, '');

    // Add mouse events for tooltip handling
    label.addEventListener('mouseenter', function(e) {
      const existingTooltip = document.querySelector('.color-name-tooltip');
      if (existingTooltip) existingTooltip.remove();

      const tooltip = document.createElement('div');
      tooltip.className = 'color-name-tooltip';
      tooltip.textContent = colorName;
      document.body.appendChild(tooltip);

      const rect = this.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();

      tooltip.style.left = rect.left + (rect.width / 2) - (tooltipRect.width / 2) + 'px';
      tooltip.style.top = (rect.top - tooltipRect.height - 10) + window.scrollY + 'px';
    });

    label.addEventListener('mouseleave', function() {
      const tooltip = document.querySelector('.color-name-tooltip');
      if (tooltip) tooltip.remove();
    });
  });
}

// Automatically run on DOMContentLoaded
document.addEventListener('DOMContentLoaded', setupColorSwatchTooltips);

// You can now also call setupColorSwatchTooltips() manually if needed





